import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase/config";

function Home() {
  const navigate = useNavigate();
  const [user] = useAuthState(auth);

  return (
    <div className='min-h-screen p-8 max-w-5xl mx-auto my-page-bg'>
      <div className='flex flex-col items-center space-y-8'>
        {/* Logo/Başlık */}
        <h1 className='text-5xl font-chirp font-bold'>J1 LISTS.COM</h1>

        {/* Alt Başlık */}
        <h2 className='text-2xl font-chirp text-center'>
          Welcome to Myrtle Beach J1 Community Hub!
        </h2>

        {/* Ana Metin */}
        <div className='text-lg font-chirp space-y-6 text-center'>
          <p>
            This website is designed with one mission in mind: to help J1
            students like you! Whether you are looking for housing, jobs,
            shopping information, or simply support, this platform is tailored
            to meet your needs.
          </p>

          <p>
            Created by a former J1 student in Myrtle Beach, the goal of this
            site is to make your experience smoother, more connected, and more
            enjoyable. We understand the challenges you face, and we aim to make
            finding resources as easy as possible.
          </p>
        </div>

        {/* İletişim Bölümü */}
        <div className='text-lg font-chirp space-y-4 text-center'>
          <h3 className='font-semibold'>Contact Us:</h3>
          <p>
            Have questions, feedback, or suggestions? We'd love to hear from
            you!
          </p>
          <p>
            For student support, feedback, or suggestions, feel free to reach
            out.
            <br />
            Interested in advertising or sponsorship opportunities? Partner with
            us to connect directly with the student community.
          </p>
          <p>
            Your ideas, experiences, and collaborations help us improve and grow
            this platform for everyone. Let's make a difference together!
          </p>
          <a href='mailto:j1listsinfo@gmail.com'>
            <p className='text-blue-600'>j1listsinfo@gmail.com</p>
          </a>
        </div>

        {/* Butonlar - Kullanıcı durumuna göre değişiyor */}
        <div className='flex gap-6 w-full max-w-2xl mt-8'>
          {user ? (
            // Giriş yapmış kullanıcı için butonlar
            <>
              <button
                onClick={() => navigate("/housing")}
                className='flex-1 py-4 text-xl font-chirp font-semibold border-2 border-blue-600 rounded hover:bg-blue-100 transition'>
                View Listings
              </button>
              <button
                onClick={() => navigate("/my-listings")}
                className='flex-1 py-4 text-xl font-chirp font-semibold border-2 border-blue-600 rounded hover:bg-blue-100 transition'>
                My Listings
              </button>
            </>
          ) : (
            // Giriş yapmamış kullanıcı için butonlar
            <>
              <button
                onClick={() => navigate("/housing")}
                className='flex-1 py-4 text-lg  font-chirp border-2 border-blue-600 rounded hover:bg-blue-100 transition'>
                I am a Student
              </button>
              <button
                onClick={() => navigate("/login")}
                className='flex-1 py-4 text-m font-chirp  border-2 border-blue-600 rounded hover:bg-blue-100 transition'>
                I am a Landlord/Employer
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Home;
